import { gql } from "@apollo/client";
import { ResourceTypeFragment } from "../../fragments/resource";

export const QUERY_FETCH_RESOURCE_TYPES = gql`
  query resourceTypes {
    resourceTypes {
      ...ResourceTypeFragment
    }
  }
  ${ResourceTypeFragment}
`;
